var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReward = function SvgReward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "reward_svg__c",
    x1: "100%",
    x2: "-2.114%",
    y1: "47.112%",
    y2: "53.259%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#003B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#006A9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "reward_svg__d",
    x1: "100%",
    x2: "0%",
    y1: "1.093%",
    y2: "98.907%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#859E99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "51.701%",
    stopColor: "#95A598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9A9888"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "reward_svg__g",
    x1: "100%",
    x2: "-2.114%",
    y1: "-12.172%",
    y2: "120.169%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#003B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#006A9A"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "reward_svg__a",
    width: "147.3%",
    height: "324%",
    x: "-23.6%",
    y: "-108%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    operator: "dilate",
    radius: 4,
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 17
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0668159965 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "reward_svg__e",
    width: "148.9%",
    height: "150%",
    x: "-24.5%",
    y: "-24.1%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    operator: "dilate",
    radius: 6,
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 17
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0668159965 0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "reward_svg__b",
    width: 237,
    height: 50,
    x: 0,
    y: 0.44,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "reward_svg__f",
    width: 237,
    height: 232,
    x: 0,
    y: 0,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-60-924h320v4402H-60z"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round",
    transform: "translate(-19 -15.44)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reward_svg__b",
    fill: "#000",
    filter: "url(#reward_svg__a)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 241,
    height: 54,
    x: -2,
    y: -1.56,
    fill: "#FFF",
    stroke: "url(#reward_svg__c)",
    strokeWidth: 4,
    rx: 2
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#reward_svg__d)",
    d: "M25.589 15.293a2.09 2.09 0 0 1 2.961-.074l1.346 1.285c.134.127.14.34.012.473l-7.339 7.743h13.335c.181 0 .33.143.336.322v8.543c0 1.435-.902 2.63-2.073 2.655H21.788c-1.175 0-2.09-1.182-2.108-2.612v-5.86l-.65.688a.33.33 0 0 1-.411.058l-.062-.046-1.346-1.285a2.107 2.107 0 0 1-.074-2.972l2.06-2.172a2.18 2.18 0 0 1-1.949-.583 2.3 2.3 0 0 1-.078-3.202c.532-.572 1.183-.815 1.811-.71-.091-.59.124-1.208.636-1.735l.026-.026a2.297 2.297 0 0 1 3.173-.052c.507.471.741 1.118.7 1.752ZM27.6 25.39h-5.665l-1.586 1.676.003.033v6.487c0 1.102.653 1.968 1.413 1.985h5.884a.25.25 0 0 1-.049-.131zm7.968 0H28.6v10.037a.25.25 0 0 1-.05.145h5.582c.762 0 1.422-.855 1.436-1.953zm-13.8-5.093-4.147 4.377c-.543.573-.52 1.48.05 2.024l1.104 1.054 5.172-5.458zm9.219-2.14a.224.224 0 0 1 .426 0l.577 1.78h1.865c.214 0 .305.27.14.4l-.008.007-1.51 1.1.577 1.781c.066.204-.161.374-.336.258l-.009-.006-1.509-1.1-1.51 1.1c-.172.126-.404-.039-.347-.241l.003-.01.576-1.781-1.51-1.1a.225.225 0 0 1 .122-.408h1.876Zm.213.797-.414 1.278a.22.22 0 0 1-.213.155h-1.338l1.083.79c.075.055.108.15.084.24l-.003.011-.414 1.278 1.083-.79a.22.22 0 0 1 .253-.007l.01.007 1.084.79L32 21.427a.23.23 0 0 1 .072-.244l.01-.007 1.082-.79h-1.338a.22.22 0 0 1-.21-.144l-.003-.011zm-3.11-3.248a1.423 1.423 0 0 0-2.017.05l-3.836 4.047 2.178 1.997 4.779-5.04Zm-8.72 2.719c-.553-.376-1.186-.27-1.716.3a1.61 1.61 0 0 0 .055 2.237c.619.603 1.598.577 2.187-.056l.095-.101.082-.087.111-.116.098-.101.603-.623-1.282-1.195a2.4 2.4 0 0 1-.224-.246Zm17.075-1.266a.16.16 0 0 1 .31 0l.35 1.127h1.132c.154 0 .22.203.103.302l-.007.006-.916.696.35 1.127c.047.154-.117.283-.244.196l-.007-.005-.916-.697-.916.697c-.125.095-.293-.029-.253-.182l.002-.009.35-1.127-.916-.696c-.125-.095-.064-.3.087-.308h1.141Zm.155.605-.231.745a.164.164 0 0 1-.155.118h-.75l.607.46a.18.18 0 0 1 .062.18l-.003.01-.232.746.606-.46a.16.16 0 0 1 .183-.007l.009.007.606.46-.232-.745c-.02-.067 0-.14.051-.184l.008-.007.606-.46h-.749a.16.16 0 0 1-.151-.108l-.004-.01zm-14.254-1.548a1.604 1.604 0 0 0-2.235.055c-.522.538-.61 1.15-.254 1.673q.108.08.205.175l1.364 1.327.054-.057.46-.495.174-.186.11-.116.12-.127.058-.06c.602-.62.577-1.6-.056-2.189",
    transform: "translate(-17.36 -15.44)"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round",
    transform: "translate(-17 -14)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#reward_svg__f",
    fill: "#000",
    filter: "url(#reward_svg__e)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 243,
    height: 238,
    x: -3,
    y: -3,
    fill: "#FFF",
    stroke: "url(#reward_svg__g)",
    strokeWidth: 6,
    rx: 2
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#reward_svg__d)",
    d: "M25.589 15.293a2.09 2.09 0 0 1 2.961-.074l1.346 1.285c.134.127.14.34.012.473l-7.339 7.743h13.335c.181 0 .33.143.336.322v8.543c0 1.435-.902 2.63-2.073 2.655H21.788c-1.175 0-2.09-1.182-2.108-2.612v-5.86l-.65.688a.33.33 0 0 1-.411.058l-.062-.046-1.346-1.285a2.107 2.107 0 0 1-.074-2.972l2.06-2.172a2.18 2.18 0 0 1-1.949-.583 2.3 2.3 0 0 1-.078-3.202c.532-.572 1.183-.815 1.811-.71-.091-.59.124-1.208.636-1.735l.026-.026a2.297 2.297 0 0 1 3.173-.052c.507.471.741 1.118.7 1.752ZM27.6 25.39h-5.665l-1.586 1.676.003.033v6.487c0 1.102.653 1.968 1.413 1.985h5.884a.25.25 0 0 1-.049-.131zm7.968 0H28.6v10.037a.25.25 0 0 1-.05.145h5.582c.762 0 1.422-.855 1.436-1.953zm-13.8-5.093-4.147 4.377c-.543.573-.52 1.48.05 2.024l1.104 1.054 5.172-5.458zm9.219-2.14a.224.224 0 0 1 .426 0l.577 1.78h1.865c.214 0 .305.27.14.4l-.008.007-1.51 1.1.577 1.781c.066.204-.161.374-.336.258l-.009-.006-1.509-1.1-1.51 1.1c-.172.126-.404-.039-.347-.241l.003-.01.576-1.781-1.51-1.1a.225.225 0 0 1 .122-.408h1.876Zm.213.797-.414 1.278a.22.22 0 0 1-.213.155h-1.338l1.083.79c.075.055.108.15.084.24l-.003.011-.414 1.278 1.083-.79a.22.22 0 0 1 .253-.007l.01.007 1.084.79L32 21.427a.23.23 0 0 1 .072-.244l.01-.007 1.082-.79h-1.338a.22.22 0 0 1-.21-.144l-.003-.011zm-3.11-3.248a1.423 1.423 0 0 0-2.017.05l-3.836 4.047 2.178 1.997 4.779-5.04Zm-8.72 2.719c-.553-.376-1.186-.27-1.716.3a1.61 1.61 0 0 0 .055 2.237c.619.603 1.598.577 2.187-.056l.095-.101.082-.087.111-.116.098-.101.603-.623-1.282-1.195a2.4 2.4 0 0 1-.224-.246Zm17.075-1.266a.16.16 0 0 1 .31 0l.35 1.127h1.132c.154 0 .22.203.103.302l-.007.006-.916.696.35 1.127c.047.154-.117.283-.244.196l-.007-.005-.916-.697-.916.697c-.125.095-.293-.029-.253-.182l.002-.009.35-1.127-.916-.696c-.125-.095-.064-.3.087-.308h1.141Zm.155.605-.231.745a.164.164 0 0 1-.155.118h-.75l.607.46a.18.18 0 0 1 .062.18l-.003.01-.232.746.606-.46a.16.16 0 0 1 .183-.007l.009.007.606.46-.232-.745c-.02-.067 0-.14.051-.184l.008-.007.606-.46h-.749a.16.16 0 0 1-.151-.108l-.004-.01zm-14.254-1.548a1.604 1.604 0 0 0-2.235.055c-.522.538-.61 1.15-.254 1.673q.108.08.205.175l1.364 1.327.054-.057.46-.495.174-.186.11-.116.12-.127.058-.06c.602-.62.577-1.6-.056-2.189",
    transform: "translate(-15.36 -13.44)"
  }))));
};
export default SvgReward;